import {makeAutoObservable} from "mobx";
import {SearchObject} from "app/common/Model/SearchObject";
import {
    pagingProductMapping,
    getProductMappingById,
    saveProductMapping,
    deleteProductMapping,
    markDeleteProductMapping, importExcelMapping
} from 'app/services/ProductMappingService';
import {Country} from "app/common/Model/Country";
import {checkSearchObject} from "app/common/LocalFunction";
import {toast} from "react-toastify";

export default class ProductMappingStore {
    listAllProductMapping = [];
    searchProductMapping = new SearchObject();
    pageProductMapping = null;
    selectedProductMapping = null;
    openFormCreateOrEdit = false;
    openFormUploadFile = false;
    openConfirmDeleteProductMapping = false;
    listProduct = [];
    constructor() {
        makeAutoObservable(this);
    }

    // getAllProductMapping = () => {
    //     if (this.listAllProductMapping?.length === 0) {
    //         getAllProductMapping()
    //             .then(({ data }) => this.listAllProductMapping = data)
    //             .catch((error) => {
    //                 console.error(error);
    //                 toast.error("Lấy dữ liệu có lỗi");
    //             });
    //     }
    // }

    pagingProductMapping = () => {
        pagingProductMapping(this.searchProductMapping)
            .then(({data}) => {
                this.pageProductMapping = data;
              
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchProductMapping) => {
        this.searchProductMapping = checkSearchObject(this.searchProductMapping, searchProductMapping);
        this.pagingProductMapping();
    }

    handleOpenFormCreateOrEdit = (productMappingId) => {
        if (Boolean(productMappingId)) {
            getProductMappingById(productMappingId)
                .then(({data}) => {
                    let newData = {
                        ...data,
                        drug: data?.productType === 1 ? {
                            id: data?.emrProductId,
                            name: data?.name
                        } : null,
                        medicalSupply: data?.productType === 2 ? {
                            id: data?.emrProductId,
                            name: data?.name
                        } : null,
                        unit: data?.productType === 3 ? {
                            id: data?.emrProductId,
                            name: data?.name
                        } : null,
                        department: data?.productType === 4 ? {
                            id: data?.emrProductId,
                            name: data?.name
                        } : null
                    }
                    this.selectedProductMapping = newData;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedProductMapping = new Country();
            this.openFormCreateOrEdit = true;
        }
    }

    saveProductMapping = (productMapping, {setSubmitting}) => {
        return saveProductMapping({
            ...productMapping,
            emrProductId: productMapping?.drug?.id || productMapping?.medicalSupply?.id || productMapping?.unit?.id || productMapping?.department?.id || null
        }).then(() => {
            this.selectedProductMapping = null;
            toast.success("Lưu thành công!");
            this.handleClosePopup();
            this.pagingProductMapping();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteProductMapping = (productMapping) => {
        this.selectedProductMapping = {id: productMapping?.id};
        this.openConfirmDeleteProductMapping = true;
    }

    handleConfirmDeleteProductMapping = () => markDeleteProductMapping(this?.selectedProductMapping?.id)
        .then(() => {
            if (this.searchProductMapping.pageIndex > 1 && this.pageProductMapping.content.length === 1) {
                this.searchProductMapping.pageIndex -= 1;
            }
            toast.success("Xóa hàng hóa thành công!")
            this.handleClosePopup();
            this.pagingProductMapping();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa hàng hóa có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteProductMapping = false;
        this.openFormUploadFile = false
    }

    resetStore = () => {
        this.searchProductMapping = new SearchObject();
        this.pageProductMapping = null;
        this.selectedProductMapping = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteProductMapping = false;
    }
    handleUploadFile = () => {
        this.openFormUploadFile = true
    }
    handleImportExcelMapping = (file) => {
        importExcelMapping(file).then(({data}) => {
            toast.success("Tải file thành công!")
            this.handleClosePopup();
        }).catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
        })
    }
}